import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A9IssuersEdit } from "./edit";
import { A9IssuersNew } from "./new";
import { A9IssuersTable } from "./table";

export default function A9Issuers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Émetteurs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A9IssuersEdit />} />
      <Route index element={<A9IssuersTable />} />
      <Route path="/new" element={<A9IssuersNew />} />
    </Routes>
  );
}
